/**
 * 共享的便签 glyph —— reminder 功能统一图标(右上角入口 + 各实体头部「加提醒」按钮共用),
 * 保证同一形状在全站一致。
 *
 * 颜色按「状态」点亮(与 WatchButton 的 Star 同款语义):
 *   lit=false → 描边 currentColor(随父级 text 颜色,通常灰/muted,表示「未设」)
 *   lit=true  → 黄色填充 + 琥珀描边(表示「已挂提醒」,也呼应 reminder 品牌黄)
 */
export function StickyNoteIcon({ lit, size = 19 }: { lit: boolean; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={lit ? '#FDE68A' : 'none'}
      stroke={lit ? '#A16207' : 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11l5-5V5a2 2 0 0 0-2-2z" />
      <path d="M15 21v-4a2 2 0 0 1 2-2h4" fill="none" />
    </svg>
  )
}
